import http from '../../api/http';
import { paramsSend } from '../../utils/util';
/**
 * 获取手机验证码
 */
export const getVerifyCode = (params) => http("get", '/user/verification/code/get', params)
/**
 * 用户注册
 */
export const newRegister = (params) => http("post", paramsSend('/user/register', params))
